import { render, staticRenderFns } from "./ModulePermissionsAccess.vue?vue&type=template&id=ef9d59c0&scoped=true"
import script from "./ModulePermissionsAccess.vue?vue&type=script&lang=js"
export * from "./ModulePermissionsAccess.vue?vue&type=script&lang=js"
import style0 from "./ModulePermissionsAccess.vue?vue&type=style&index=0&id=ef9d59c0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9d59c0",
  null
  
)

export default component.exports